// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-widget.frisbuy-layout-line .frisbuy-scroll-wrapper.active-grab-scroll{scroll-behavior:auto!important}.frisbuy-widget.frisbuy-layout-line .frisbuy-scroll-wrapper.active-grab-scroll .frisbuy-gallery-posts .frisbuy-gallery-post{cursor:grab}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
